class RecentlyViewed extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.selector;
    this.sliderContainer = document.getElementById(
      `recently-viewed__${this.sectionId}-products`
    );
  }

  connectedCallback() {
    let self = this;
    let products = "";
    let searchUrl = `${window.routes.search}?view=recently-viewed&type=product&q=`;
    let recentlyViewed =
      JSON.parse(localStorage.getItem("recently-viewed")) || [];

    if (recentlyViewed.length > 0) {
      recentlyViewed.forEach((id) => {
        products += `id:${id} OR `;
      });

      searchUrl = searchUrl + encodeURIComponent(products);

      fetch(searchUrl)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const count = html.querySelectorAll(".product-grid").length;
          if (count > 0) {
            self.sliderContainer.innerHTML =
              html.querySelector(".product-grid").innerHTML;

            if (html.querySelectorAll(".product-card").length > 1) {
              const swiperElement = self.sliderContainer;
              const config = {
                dots: true,
                loop: false,
                arrows: false,
                autoplay: false,
                spaceBetween: 20,
                breakpoints: {
                  320: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                  },
                  768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                  },
                  880: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                  },
                  1200: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                  },
                },
                navigation: {
                  nextEl: ".swiper-arrow-recently__viewed__next",
                  prevEl: ".swiper-arrow-recently__viewed__prev",
                },
                pagination: {
                  el: ".swiper-recently__viewed-pagination",
                  clickable: true,
                },
              };

              new Swiper(swiperElement, config);
              swiperElement.classList.add("block-swiper__initialize");
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      document
        .querySelector(".recently-viewed__collection")
        .classList.add("hidden");
    }
  }
}
customElements.define("recently-viewed", RecentlyViewed);
